import { EventEmitter, Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular'
import swal from 'sweetalert';
import { NUBE_AWS, URL_IA, URL_SERVICIOS_AWS, URL_WHATSAPP, WHATSAPP_TOKEN } from '../../config/url.servicio';
import * as uuid from 'uuid';
import { Http, Headers, RequestOptions } from '@angular/http';
import { InformesProvider } from '../informes/informes';
import { CompaniasProvider } from '../companias/companias';
declare var Swal:any
import QRCode from 'qrcode';
@Injectable()
export class UtilsProvider {
  public shortcuts: { [key: string]: any } = {}; // Almacena los atajos por página
  shortcutAssigned = new EventEmitter<{ value: string; key: string }>(); // Evento para notificar cambios
  shortcutUpdated = new EventEmitter<{ page: string, shortcuts: any }>();

  constructor(public alertControllers: AlertController,public http: Http,
    public utilsInformes:InformesProvider,
    public servicioCompania:CompaniasProvider,
  ) { }

  mostrarMensaje(mensaje,title) {
    let alert = this.alertControllers.create({
      title: title,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present();
  }

  mensajeMuestro(title:any,text:any,icon:any){
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      confirmButtonText: 'Aceptar'
    });
  }

  mensajeMuestroConCerrado(title: any, text: any, icon: any, autoClose: boolean) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      confirmButtonText: 'Aceptar',
      timer: autoClose ? 3000 : undefined,
      timerProgressBar: autoClose,
      showConfirmButton: !autoClose,
      allowOutsideClick: !autoClose,
      customClass: {
        popup: 'custom-popup',
        title: 'custom-title',
        confirmButton: 'custom-button'
      },
      didOpen: () => {
        // Aplicar estilos directamente al popup al abrirlo
        const popup = document.querySelector('.custom-popup') as HTMLElement;
        if (popup) {
          popup.style.borderRadius = '10px';
          popup.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)';
          popup.style.padding = '20px';
          popup.style.background = '#f8f9fa';
        }

        const title = document.querySelector('.custom-title') as HTMLElement;
        if (title) {
          title.style.fontWeight = 'bold';
          title.style.color = '#333';
          title.style.fontSize = '18px';
        }

        const button = document.querySelector('.custom-button') as HTMLElement;
        if (button) {
          button.style.backgroundColor = '#007bff';
          button.style.color = 'white';
          button.style.borderRadius = '5px';
          button.style.padding = '10px 20px';
          button.style.fontWeight = 'bold';
        }
      }
    });
  }



  mensajeConfirmacionDos(title:any,text:any,icon:any,confirmButtonText:any,cancelButtonText:any){
    return Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText
    }).then((result) => {
      return result.value
    })
  }

  mostrarMensajeHtml(textoBotonConfirmar: string, titulo: string, icono: string, stringHtml: string){
    Swal.fire({
      title: '<strong> ' + titulo + '</strong>',
      icon: icono,
      html: stringHtml,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText:  textoBotonConfirmar,
      confirmButtonColor: '#3085d6',
      timerProgressBar: true,
      padding: '6rem'
    })
  }

  mensajeConfirmacion(title:any,text:any,icon:any,buttons: string[],dangerMode:any){

    return swal({
      title: title,
      text: text,
      icon: icon,
      buttons: buttons,
      dangerMode: dangerMode
    })
  }


  mostrarReciboDeCajaEnPantalla(elNroFactura: any, elReciboMuestra: any, cufe?: string) {
    let recibo = `<div align="left" style='font-family: monospace;'>`;

    if (NUBE_AWS) {
      elReciboMuestra = elReciboMuestra.length > 0 ? elReciboMuestra : JSON.parse(elReciboMuestra['_body']).data[0];
    }

    for (let index: any = 0; index < elReciboMuestra.length; index++) {
      recibo += elReciboMuestra[index]['reciboCaja'].replace(/\ /g, '&nbsp;') + '<br/>';
    }

    recibo += '</div>';

    //cufe = 'a26a0039657c46f98b6f888e20430e4be5c990a52b980d7e0e4eb1c7c908949750536ddc0e8cc20205c96b32b8687c10';

    // URL de la DIAN con el CUFE
    const urlDian = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;

    // Generar el QR y agregarlo al recibo
    if (cufe !== undefined) {
      const titulo = 'Cufe / Cude';

      // Generar el QR usando la librería QRCode
      QRCode.toDataURL(urlDian, { width: 200 }, (err, url) => {
        if (err) {
          console.error('Error generando el QR:', err);
          return;
        }

        // Incluir el QR como imagen en el HTML del recibo
        recibo += `<div style="text-align: center; font-family: monospace; margin-top: 20px;">
                      <p><b>${titulo}</b></p>
                      <p>${cufe}</p>
                      <img src="${url}" alt="QR Code" style="margin-top: 10px;"/>
                      <p style="font-size: smaller;">Escanee el QR para validar en la DIAN.</p>
                   </div>`;

        let tituloRecibo = elNroFactura != '' ? 'Orden de entrega ' + elNroFactura : 'Visualización orden de entrega';

        // Mostrar el recibo (incluido el QR) en pantalla
        this.mostrarMensajeHtml('Salir', tituloRecibo, '', recibo);
      });
    } else {
      let tituloRecibo = elNroFactura != '' ? 'Orden de entrega ' + elNroFactura : 'Visualización orden de entrega';

      // Mostrar el recibo sin QR en pantalla
      this.mostrarMensajeHtml('Salir', tituloRecibo, '', recibo);
    }
  }



  async enviarcomandasUtils(
    valorTotalVenta: number,valorTotalDevolver: any,
    usuariosId:any,companiasId:any,domicilioCheck:any,clientesId:any,
    listaProductosSeleccionados:any,
    turno: any,CheckPorcentajeServicio:any,
    formaPagoSeleccionada:any, modoDesconectado:boolean = false
  ) {
    try {
      if ( valorTotalVenta === 0) {
        return
      }
      if ( valorTotalVenta <= 0){
          return
      }
      let datosAdicionales = {
          valorTotalVenta: valorTotalVenta,
          totalPagado: valorTotalDevolver,
          valorTotalDevolver: (valorTotalDevolver - valorTotalVenta),
          companiasId:companiasId
      }
      const usuarioId = usuariosId
      if (domicilioCheck) {
        datosAdicionales['usuariosId'] = usuarioId;
        if(datosAdicionales['usuariosId'] == 1) {
          this.mensajeMuestro('Advertencia','Debe ingresar el usuario','Advertencia')
          return
        }
      }

      datosAdicionales['clientesId'] = clientesId
      if (domicilioCheck) {
            const clienteId = clientesId
            datosAdicionales['clientesId'] = clienteId;
            if (datosAdicionales['clientesId'] === undefined) {
              datosAdicionales['clientesId'] = 1
            }
      }

      if((clientesId == 0 || clientesId == 1) && domicilioCheck === true){
        this.mensajeMuestro('Advertencia','Debe ingresar el cliente','Advertencia')
        return
      }

      let fechaHoy = new Date()
      let nuevafechaIngreso = fechaHoy.toLocaleDateString()
      nuevafechaIngreso = nuevafechaIngreso.split('/').reverse().join('-')
      let fecha = this.formatearCadena(nuevafechaIngreso)
      let uuids = uuid.v4();

      let nuevoArray = []
      if(listaProductosSeleccionados.length === 0) {
        this.mensajeMuestro('Advertencia','No ha seleccionado ningun producto','Verifique')
        return
      }
      let valor = valorTotalVenta

      for(var k =0;k < listaProductosSeleccionados.length;k++){
        listaProductosSeleccionados[k]['numeromesa'] = 200
        listaProductosSeleccionados[k]['nombreProducto'] = listaProductosSeleccionados[k]['nombreProducto']
        listaProductosSeleccionados[k]['turno'] = turno
        listaProductosSeleccionados[k]['valorImpuestoCalculo'] = listaProductosSeleccionados[k]['valorImpuestoCalculo']
        listaProductosSeleccionados[k]['tipoImpuesto'] = listaProductosSeleccionados[k]['tipoImpuesto']
        listaProductosSeleccionados[k]['clientesId'] = datosAdicionales['clientesId']
        listaProductosSeleccionados[k]['companiasId'] = datosAdicionales['companiasId']
        listaProductosSeleccionados[k]['usuariosId'] = usuarioId
        listaProductosSeleccionados[k]['valorTotalVenta'] = valor
        listaProductosSeleccionados[k]['totalPagado'] = 0
        listaProductosSeleccionados[k]['descripcion'] = listaProductosSeleccionados[k]['descripcion']
        listaProductosSeleccionados[k]['valorTotalDevolver'] = 0
        listaProductosSeleccionados[k]['fecha'] = fecha
        listaProductosSeleccionados[k]['domicilio'] = domicilioCheck === true ? 'S': 'N'
        listaProductosSeleccionados[k]['estado'] = 'G'
        listaProductosSeleccionados[k]['Uuid'] = uuids
        let nuevoCodigo = `${listaProductosSeleccionados[k]['Uuid'].substr(0,6)}-${listaProductosSeleccionados[k]['companiasId']}`;
        let Uuid = `${listaProductosSeleccionados[k]['Uuid'].substr(0,6)}-${datosAdicionales['companiasId']}`
        listaProductosSeleccionados[k]['codigo'] = Uuid
        if(listaProductosSeleccionados[k]['centroDeCostosId']=="0"){
          listaProductosSeleccionados[k]['centroDeCostosId'] = 0
        }

        if(listaProductosSeleccionados[k]['estadoGestion'] === undefined || listaProductosSeleccionados[k]['estadoGestion'] === null || listaProductosSeleccionados[k]['estadoGestion'] === "0") {
          listaProductosSeleccionados[k]['centroDeCostosGestionId'] = 0
        }

        if(listaProductosSeleccionados[k]['imagen']==null){
        listaProductosSeleccionados[k]['imagen']= "https://res.cloudinary.com/drqk6qzo7/image/upload/v1517108463/Sin_imagen_disponible_gsghfo.jpg"
      }

        let valorImpuesto = 0
        valorImpuesto = parseInt(listaProductosSeleccionados[k]['valorImpuesto'])
        let valorProducto = 0
        valorProducto = parseInt(listaProductosSeleccionados[k]['valorProducto'])
        let valorTotalVenta = parseInt(listaProductosSeleccionados[k]['valorVenta']) *  parseFloat(listaProductosSeleccionados[k]['cantidad'])

        nuevoArray.push({
          'cantidad': parseFloat(listaProductosSeleccionados[k]['cantidad']),
          'gruposProductosId': listaProductosSeleccionados[k]['gruposProductosId'],
          'imagen': listaProductosSeleccionados[k]['imagen'],
          'nombreProducto': listaProductosSeleccionados[k]['nombreProducto'],
          'numeromesa': 200,
          'productosId': listaProductosSeleccionados[k]['productosId'],
          'tipoProducto': listaProductosSeleccionados[k]['tipoProducto'],
          'valorImpuesto': valorImpuesto,
          'valorProducto': valorProducto,
          'valorVenta': parseInt(listaProductosSeleccionados[k]['valorVenta']),
          'clientesId': listaProductosSeleccionados[k]['clientesId'],
          'companiasId': listaProductosSeleccionados[k]['companiasId'],
          'totalPagado': listaProductosSeleccionados[k]['totalPagado'],
          'usuariosId': usuarioId,
          'valorTotalDevolver': listaProductosSeleccionados[k]['valorTotalDevolver'],
          'valorTotalVenta': valorTotalVenta,
          'centroDeCostosId': listaProductosSeleccionados[k]['centroDeCostosId'],
          'codigoCentroDeCosto': listaProductosSeleccionados[k]['codigoCentroDeCosto'],
          'fecha': listaProductosSeleccionados[k]['fecha'],
          'domicilio': listaProductosSeleccionados[k]['domicilio'],
          'estado': listaProductosSeleccionados[k]['estado'],
          'Uuid': listaProductosSeleccionados[k]['Uuid'],
          'codigo': listaProductosSeleccionados[k]['codigo'] === undefined ? nuevoCodigo : listaProductosSeleccionados[k]['codigo'],
          'color': listaProductosSeleccionados[k]['color'],
          'descripcion': listaProductosSeleccionados[k]['descripcion'],
          'turno': JSON.stringify(turno),
          'incluirServicio': CheckPorcentajeServicio ? 'S' : 'N',
          'formaDePago': formaPagoSeleccionada,
          'imprimirProducto': listaProductosSeleccionados[k]['imprimirProducto'],
          'imprimirGeneral': listaProductosSeleccionados[k]['imprimirGeneral'],
          'centroDeCostosGestionId': listaProductosSeleccionados[k]['centroDeCostosGestionId'],
          'esUnTurnoGuardado': 'S',
          'valorImpuestoCalculo': listaProductosSeleccionados[k]['valorImpuestoCalculo'],
          'tipoImpuesto' : listaProductosSeleccionados[k]['tipoImpuesto']
         })
      }

      const codigo = nuevoArray[0]['codigo']
      let descripcion = nuevoArray[0]['descripcion']
      const turnoModoDesconectado = nuevoArray[0].turno;
        if(modoDesconectado) {
          const data:any = await this.servicioCompania.guardarComandasModoDesconectado(nuevoArray,turnoModoDesconectado);
          let resultado = data
          let resulJson = JSON.parse(resultado['_body']);
          let resultadoFinal = resulJson;
          let dataGuardarComandasMeseroDesconect = []
          if (!resultadoFinal || resultadoFinal.length === 0) {
            console.log('comandas','Valide no se guardo la comanda...','warning')
          } else {
            dataGuardarComandasMeseroDesconect = resultadoFinal
            return resultadoFinal
          }
        } else {
          let dataGuardarComandasMesero = await this.guardarComandasMeseroPorCentroDeCostoUtils(nuevoArray, codigo, descripcion).toPromise();
          let dataJson = NUBE_AWS ? JSON.parse(dataGuardarComandasMesero['_body']) : dataGuardarComandasMesero
          let dataResponse = NUBE_AWS ? dataJson.data : dataGuardarComandasMesero
          dataGuardarComandasMesero = dataResponse
          return dataGuardarComandasMesero
        }

      } catch(e) {
        console.log('errors', e)
        return []
      }
   }

    formatearCadena(cadena){
      let valorinicial = cadena.length
      let primero,segundo,ultimo
      primero = cadena.substr(0,4)
      segundo = cadena.substr(5,2)
      ultimo = cadena.substr(valorinicial - 2, valorinicial)
      if(valorinicial != 10){
        let recorrer = cadena.split('-')
        for(var i = 0; i < recorrer.length;i++) {
          if(i == 1 && recorrer[i].length == 1) {
            segundo = `0${recorrer[i]}`
          }
          if(i == 2 && recorrer[i].length == 1){
            ultimo = `0${recorrer[i]}`
          }
        }
      }
      return `${primero}-${segundo}-${ultimo}`
    }

    guardarComandasMeseroPorCentroDeCostoUtils (data: any,codigo: string,descripcion: string){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        if (descripcion == undefined) {
          descripcion = ""
        }
        let request = {
          name: "almacenarComandasMeseroTurnosPorCentroDeCosto",
          parameters : {
            "datos": JSON.stringify(data),
            "codigo": codigo,
            "descripcion":descripcion
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http
            .post(`${url_servicio}/procedure`, request, options);
      }
    }

    descargarArchivoExcel(data:any,nombre:string){


      if(data.length > 0){
            let valores = data
            this.utilsInformes.exportToExcel(data,nombre)
            .then((result: any) => {
                console.log('result', result)
              }).catch((error)=> {
                console.log('error', error)
              })
          }else{
            console.log('No se logro gestionar la información','Advertencia!','Advertencia')
            return false
          }

    }

    async buscarAtajos(companiasId:any,pagina:any) {
      try {
        let response;
         const url_servicio = URL_SERVICIOS_AWS;
          const valores = {
            name: "buscarAtajos",
            parameters: { companiasId, pagina }
          };
          const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }

    async gestionarAtajos(companiasId:any,pagina:any,atajo:any) {
      try {
        let response;
         const url_servicio = URL_SERVICIOS_AWS;
          const valores = {
            name: "gestionarAtajos",
            parameters: { companiasId, pagina,atajo: JSON.stringify(atajo) }
          };
          const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }



    setShortcuts(page: string, shortcuts: any) {
      this.shortcuts[page] = shortcuts;

      // Guardar en localStorage
      localStorage.setItem("shortcuts", JSON.stringify(this.shortcuts));
      this.shortcutUpdated.emit({ page, shortcuts });
    }

    getShortcuts(page: string) {
      // Recuperar desde localStorage en caso de que `this.shortcuts` esté vacío
      if (Object.keys(this.shortcuts).length === 0) {
        const storedShortcuts = localStorage.getItem("shortcuts");
        if (storedShortcuts) {
          this.shortcuts = JSON.parse(storedShortcuts);
        }
      }


      return this.shortcuts[page] || {};
    }

    async verificarPermiso(nombreModulo: string, titulo: string, mensaje: string): Promise<boolean> {
      let companiasId = await localStorage.getItem('companiasId');

      let datosResponse = await this.servicioCompania.buscarPermisosPorRutaYCompania(nombreModulo, companiasId);
      let response = datosResponse.json();

      if (response && response.data && response.data[0] && response.data[0].length > 0) {
        if (response.data[0].activo === 0) {
          this.mensajeMuestro(titulo, mensaje, 'warning');
          return false; // No tiene permiso
        }
        return true; // Tiene permiso
      } else {
        this.mensajeMuestro(titulo, mensaje, 'warning');
        return false; // No tiene permiso
      }
    }

    async consultaIA(companiasId: any, mensaje: any) {
      try {
        let url_servicio = URL_IA;

        // Estructura correcta del body
        const valores = [{
            companiasId: Number(companiasId),
            mensaje: mensaje
          }];

        const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
        const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

        //url_servicio = 'http://localhost:4000/consultarBD'
        // Realizar la petición POST
        const response = await this.http.post(url_servicio, valores, options).toPromise();
        // 🔥 Solución: Hacer doble JSON.parse() si es necesario
        let responseData = response.json();

        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData);  // Desanidar JSON si es necesario
        }

        if (responseData.data && typeof responseData.data === "string") {
          responseData.data = JSON.parse(responseData.data);  // Desanidar `data`
        }

        return responseData;


      } catch (error) {
        console.error('🚨 Error en consultaIA:', error);
        throw error;
      }
    }

    async buscarPromptiaSeguimientos(companiasId:any) {
      try {
        let response;
         const url_servicio = URL_SERVICIOS_AWS;
          const valores = {
            name: "buscarPromptiaSeguimientos",
            parameters: { companiasId }
          };
          const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }


    async buscarAFN(consulta:any) {
      try {
        let response;
         const url_servicio = URL_SERVICIOS_AWS;
          const valores = {
            name: "cualquiercosa",
            parameters: { afn: consulta }
          };
          const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }


    async enviarMensajeWhatsApp(numeroCelular: string, mensaje: string) {
      try {
        let response;
         const url_whatsapp = URL_WHATSAPP;
         const whatsapp_token = WHATSAPP_TOKEN;
         const data = {
          messaging_product: "whatsapp",
          recipient_type: "individual",
          to: numeroCelular,
          type: "text",
          text: {
            preview_url: false,
            body: mensaje
          }
        };
          const headers = new Headers({ 'Content-Type': 'application/json',
            'Authorization': `Bearer ${whatsapp_token}`
           }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(url_whatsapp, data, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }


    async procesarYEnviarCierrePorWhatsApp(datos, numerocelular) {
      // Filtrar datos correctamente eliminando solo líneas vacías o separadores
      const datosFiltrados = datos
        .map(item => item.reciboCaja ? item.reciboCaja.trim() : null)
        .filter(text => text && text !== "------------------------------------" && text !== "");

        // Función para extraer valores específicos
        const extraerValor = (clave) => {
          const linea = datosFiltrados.find(text => text.includes(clave));
          return linea ? linea.replace(clave, "").trim() : "No disponible";
        };

        // Extraer consecutivos
        const consecutivos = extraerValor("Consecutivos:");

        // Extraer el detalle de impuestos
        const impuestosIndex = datosFiltrados.findIndex(text => text.includes("DETALLE IMPUESTOS"));
        const detalleImpuestos = impuestosIndex !== -1
          ? datosFiltrados.slice(impuestosIndex + 1, impuestosIndex + 5).join("\n")
          : "0";

        // Extraer pedidos eliminados
        const pedidosEliminados = extraerValor("Pedidos eliminados:");

        // Extraer ventas devueltas
        const ventasDevueltasIndex = datosFiltrados.findIndex(text => text.includes("VENTAS DEVUELTAS"));
        const ventasDevueltas = ventasDevueltasIndex !== -1
          ? datosFiltrados.slice(ventasDevueltasIndex, ventasDevueltasIndex + 2).join("\n")
          : "0";

        // Extraer propinas
        const propinasIndex = datosFiltrados.findIndex(text => text.includes("PROPINAS"));
        const propinas = (propinasIndex !== -1 && propinasIndex + 1 < datosFiltrados.length && /\d/.test(datosFiltrados[propinasIndex + 1]))
          ? datosFiltrados[propinasIndex + 1]
          : "0";

        // Extraer detalle de ventas
        const detalleVentasIndex = datosFiltrados.findIndex(text => text.includes("DETALLE VENTAS"));
        const detalleVentas = detalleVentasIndex !== -1
          ? datosFiltrados.slice(detalleVentasIndex + 2).join("\n")
          : "0";

        // Extraer dinámicamente todas las formas de pago con recuento y diferencia
        const metodosPagoIndex = datosFiltrados.findIndex(text => text.includes("METODOS DE PAGO"));
        const metodosPago = {};
        if (metodosPagoIndex !== -1) {
          for (let i = metodosPagoIndex + 1; i < datosFiltrados.length; i++) {
            if (datosFiltrados[i].includes("Recuento Cajero:") || datosFiltrados[i].includes("DIFERENCIA:")) continue;

            // Detectar fin de métodos de pago
            if (datosFiltrados[i] === "PROPINAS" || datosFiltrados[i].includes("Total Ventas:")) break;

            // Verificar que sea un método de pago válido (contiene ":")
            if (!datosFiltrados[i].includes(":")) continue;

            const metodoLinea = datosFiltrados[i].split(":");
            const metodo = metodoLinea[0].trim(); // Nombre del método
            const valor = metodoLinea.length > 1 ? metodoLinea[1].trim() : "";


            // Buscar "Recuento Cajero:" y "DIFERENCIA:"
            // const recuentoLinea = datosFiltrados[i + 1]?.includes("Recuento Cajero:") ? datosFiltrados[i + 1] : null;
            // const diferenciaLinea = datosFiltrados[i + 2]?.includes("DIFERENCIA:") ? datosFiltrados[i + 2] : null;

            // const recuentoCajero = recuentoLinea ? recuentoLinea.replace("Recuento Cajero:", "").trim() : "0";
            // const diferencia = diferenciaLinea ? diferenciaLinea.replace("DIFERENCIA:", "").trim() : "0";
            const recuentoLinea = (datosFiltrados[i + 1] && datosFiltrados[i + 1].includes("Recuento Cajero:")) ? datosFiltrados[i + 1] : null;
            const diferenciaLinea = (datosFiltrados[i + 2] && datosFiltrados[i + 2].includes("DIFERENCIA:")) ? datosFiltrados[i + 2] : null;

            const recuentoCajero = recuentoLinea ? recuentoLinea.replace("Recuento Cajero:", "").trim() : "0";
            const diferencia = diferenciaLinea ? diferenciaLinea.replace("DIFERENCIA:", "").trim() : "0";


            if (metodo && valor) {
              metodosPago[metodo] = {
                valor,
                recuentoCajero,
                diferencia
              };
            }
          }
        }

        // Generar el mensaje de WhatsApp
        let mensaje = `📢 *Resumen del Cierre de Ventas* 📢\n
        📅 *Fecha:* ${extraerValor("Fecha ventas:")}
        👤 *Cajero:* ${extraerValor("Cajero:")}
        🔢 *Consecutivos:* ${consecutivos}
        🛒 *Cantidad de Ventas:* ${extraerValor("Cantidad ventas:")}

        💰 *Métodos de Pago:*`;

        for (const metodo in metodosPago) {
          mensaje += `\n  - *${metodo}:* ${metodosPago[metodo].valor}
              - *Recuento Cajero:* ${metodosPago[metodo].recuentoCajero}
              - *Diferencia:* ${metodosPago[metodo].diferencia}`;
        }

        mensaje += `\n\n📊 *Totales:*
          ✅ *Total Ventas:* ${extraerValor("Total Ventas:")}
          ❌ *Total Egresos:* ${extraerValor("Total Egresos:")}
          🔥 *Total General:* ${extraerValor("Total General:")}

        📌 *Detalle de Impuestos:*
        ${detalleImpuestos}

        🛍 *Pedidos Eliminados:* ${pedidosEliminados}

        📄 *Ventas Devueltas:*
        ${ventasDevueltas}
        🍽 *Propinas:* ${propinas}

        🛍 *Detalle de Ventas:*\n${detalleVentas}`;

     await this.enviarMensajeWhatsApp(numerocelular, mensaje)
    }

    async buscarTelefonos(companiasId:any) {
      try {
        let response;
         const url_servicio = URL_SERVICIOS_AWS;
          const valores = {
            name: "buscarTelefonos",
            parameters: { companiasId }
          };
          const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
          const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

          response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
          return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en buscarAtajos:', error);
        throw error;
      }
    }

}



// WEBPACK FOOTER //
// ./src/providers/utils/utils.ts